module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-nowrap middle-xs sandbox-navbar",
    staticStyle: {
      "padding": "0px 30px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "center-xs flex-grow italics pl-body-1"
  }, [_c('pl-button', {
    staticClass: "pl-secondary-font",
    staticStyle: {
      "font-weight": "bold"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openParlayUrl.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "demo-title"
  }, [_vm._v("This is a Parlay Online Interactive Demo:")]), _vm._v(" "), _c('span', [_vm._v("Learn More")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex flex-nowrap end-xs col-xs-1"
  }, [(!_vm.getIsAuthenticated) ? [_c('pl-button', {
    staticClass: "pl-white-font pl-primary",
    staticStyle: {
      "border": "white 1px solid",
      "box-shadow": "none"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/account/login')
      }
    }
  }, [_vm._v("\n        sign in\n      ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-white-font pl-primary",
    staticStyle: {
      "border": "white 1px solid",
      "box-shadow": "none"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/account/signup')
      }
    }
  }, [_vm._v("\n        sign up\n      ")])] : _c('div', [_c('pl-button', {
    staticClass: "pl-white-font pl-primary",
    staticStyle: {
      "border": "white 1px solid",
      "box-shadow": "none"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push('/')
      }
    }
  }, [_vm._v("\n        View My Dashboard\n      ")])], 1)], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-1 row clickable",
    staticStyle: {
      "padding": "0 0 0 20px",
      "margin": "0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "40px",
      "height": "48px"
    },
    attrs: {
      "src": "/static/logos/parlay_logo_3.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4ce178be!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineWalkthrough/onlineWalkthrough.navbar.vue
// module id = 1918
// module chunks = 61